import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { AppLocale, SITE_NAME, BAND_NAME, BAND_NAME_JP, SITE_EMAIL } from 'constant';

import { LanguageContext } from 'context/languageContext';

import Layout from 'components/Layout';
import SideBar from 'components/SideBar';
import Title from 'components/ui/Title';

import {
  Wrapper,
} from './PrivacyPolicyPage.styles';

const PrivacyPolicyPage = () => {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  return (
    <Layout sidebar={(<SideBar />)}>
      <Wrapper>
        <Title size="big" color="secondary">
          {intl.formatMessage({ id: 'privacyPolicy.title' }, {
            bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
          })}
        </Title>
        <table>
          <tbody>
          <tr>
            <td>{intl.formatMessage({ id: 'privacyPolicy.effectiveDate.title' })}</td>
            <td>{intl.formatMessage({ id: 'privacyPolicy.effectiveDate.desc' })}</td>
          </tr>
          <tr>
            <td>{intl.formatMessage({ id: 'privacyPolicy.websiteName.title' })}</td>
            <td>
              {intl.formatMessage({ id: 'privacyPolicy.websiteName.desc' }, {
                siteName: SITE_NAME
              })}
            </td>
          </tr>
          <tr>
            <td>{intl.formatMessage({ id: 'privacyPolicy.websiteUrl.title' })}</td>
            <td><Link to="https://fans4oneokrock.com">https://fans4oneokrock.com</Link></td>
          </tr>
          </tbody>
        </table>
        <p>
          {intl.formatMessage({ id: 'privacyPolicy.generalDesc' }, {
            bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
          })}
          </p>
        <Title size="normal" color="primary">
          {intl.formatMessage({ id: 'privacyPolicy.dataCollection.title' })}
        </Title>
        <p>{intl.formatMessage({ id: 'privacyPolicy.dataCollection.paragraph1' })}</p>
        <ul>
          <li>{intl.formatMessage({ id: 'privacyPolicy.dataCollection.listItem1' })}</li>
          <li>{intl.formatMessage({ id: 'privacyPolicy.dataCollection.listItem2' })}</li>
          <li>{intl.formatMessage({ id: 'privacyPolicy.dataCollection.listItem3' })}</li>
        </ul>
        <p>{intl.formatMessage({ id: 'privacyPolicy.dataCollection.paragraph2' })}</p>
        <ul>
          <li>{intl.formatMessage({ id: 'privacyPolicy.dataCollection.listItem4' })}</li>
          <li>{intl.formatMessage({ id: 'privacyPolicy.dataCollection.listItem5' })}</li>
          <li>{intl.formatMessage({ id: 'privacyPolicy.dataCollection.listItem6' })}</li>
        </ul>
        <p>{intl.formatMessage({ id: 'privacyPolicy.dataCollection.paragraph3' })}</p>
        <Title size="normal" color="primary">
          {intl.formatMessage({ id: 'privacyPolicy.informationUsage.title' })}
        </Title>
        <p>{intl.formatMessage({ id: 'privacyPolicy.informationUsage.paragraph1' })}</p>
        <ul>
          <li>{intl.formatMessage({ id: 'privacyPolicy.informationUsage.listItem1' })}</li>
          <li>{intl.formatMessage({ id: 'privacyPolicy.informationUsage.listItem2' })}</li>
          <li>{intl.formatMessage({ id: 'privacyPolicy.informationUsage.listItem3' })}</li>
        </ul>
        <p>{intl.formatMessage({ id: 'privacyPolicy.informationUsage.paragraph2' })}</p>
        <Title size="normal" color="primary">
          {intl.formatMessage({ id: 'privacyPolicy.cookies.title' })}
        </Title>
        <p>{intl.formatMessage({ id: 'privacyPolicy.cookies.paragraph1' })}</p>
        <Title size="normal" color="primary">
          {intl.formatMessage({ id: 'privacyPolicy.links.title' })}
        </Title>
        <p>{intl.formatMessage({ id: 'privacyPolicy.links.paragraph1' })}</p>
        <Title size="normal" color="primary">
          {intl.formatMessage({ id: 'privacyPolicy.copyright.title' })}
        </Title>
        <p>
          {intl.formatMessage({ id: 'privacyPolicy.copyright.paragraph1' }, {
            bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP,
            email: <Link to={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</Link>
          })}
        </p>
        <Title size="normal" color="primary">
          {intl.formatMessage({ id: 'privacyPolicy.thirdParty.title' })}
        </Title>
        <p>{intl.formatMessage({ id: 'privacyPolicy.thirdParty.paragraph1' })}</p>
        <p>
          {intl.formatMessage({ id: 'privacyPolicy.thirdParty.paragraph2' }, {
            link: <Link to="https://www.okta.com/privacy-policy/" target="_blank">https://www.okta.com/privacy-policy/</Link>
          })}
        </p>
        <Title size="normal" color="primary">
          {intl.formatMessage({ id: 'privacyPolicy.security.title' })}
        </Title>
        <p>{intl.formatMessage({ id: 'privacyPolicy.security.paragraph1' })}</p>
        <Title size="normal" color="primary">
          {intl.formatMessage({ id: 'privacyPolicy.userRights.title' })}
        </Title>
        <p>
          {intl.formatMessage({ id: 'privacyPolicy.userRights.paragraph1' }, {
            email: <Link to={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</Link>
          })}
        </p>
        <Title size="normal" color="primary">
          {intl.formatMessage({ id: 'privacyPolicy.contact.title' })}
        </Title>
        <p>
          {intl.formatMessage({ id: 'privacyPolicy.contact.paragraph1' }, {
            email: <Link to={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</Link>
          })}
        </p>
        <hr />
        <p>{intl.formatMessage({ id: 'privacyPolicy.general.declaimer' })}</p>
      </Wrapper>
    </Layout>
  );
};

export default PrivacyPolicyPage;
